import { createContext, PropsWithChildren } from "react";
import type { ID } from "types";
import useKYCSettings from "./useKYCSettings";
import useKYCSettingsStateSelectors from "./useKYCSettingsStateSelectors";

export const KYCSettingsStateSelectorsContext = createContext({} as ReturnType<
    typeof useKYCSettingsStateSelectors
>);
export const KYCSettingsActionsContext = createContext({} as Omit<
    ReturnType<typeof useKYCSettings>,
    | 'kycSettingsState'
>);
export const KYCMerchantIdContext = createContext<ID | undefined>(undefined);

type Props = {
    readonly merchantId?: ID;
};

const KYCSettingsProvider = ({ merchantId, children }: PropsWithChildren<Props>) => {
    const {
        kycSettingsState,
        ...kycSettingsActions
    } = useKYCSettings();

    return (
        <KYCMerchantIdContext.Provider value={merchantId}>
            <KYCSettingsActionsContext.Provider
                value={kycSettingsActions}
            >
                <KYCSettingsStateSelectorsContext.Provider
                    value={useKYCSettingsStateSelectors(kycSettingsState)}
                >
                    {children}
                </KYCSettingsStateSelectorsContext.Provider>
            </KYCSettingsActionsContext.Provider>
        </KYCMerchantIdContext.Provider>
    );
};

export default KYCSettingsProvider;
